import BaseComponent from '../../../../../common/js/BaseComponent';
import ProductCard from './ProductCard';
import Helper from '../../../../../common/utils/helper';
import Favorite from './Favorite';
import Login from '../Auth/Login';
import ColorCard from './ColorCard';

enum TemplateProductsEnum {
    PRODUCTS = 'products',
    COLORS = 'colors',
    STOCKS = 'stocks',
}

enum PageEnum {
    // @ts-ignore
    PRODUCTS = [12, 24, 48, 92],
    // @ts-ignore
    COLORS = [45, 90, 180, 360],
}

export default class ProductFilter extends BaseComponent {
    private TEMPLATE_PRODUCTS: TemplateProductsEnum;

    private TEMPLATE_FILTERS: string;

    private productsContainerId: string;

    private filtersContainerId: string;

    private loaderContainerId: string;

    private selectedFilters: { [key: string]: any; };

    private hashKey: string | null;

    private hashCurrent: string | null;

    private cache: { [key: string]: any; };

    private productsPage: string | number;

    private productsPageRegex: RegExp;

    private productsOrder: string | number | string[];

    private productsOrderRegex: RegExp;

    private productsQuantity: string | number | string[];

    private productsQuantityRegex: RegExp;

    private filtersRegex: RegExp;

    private templatesRegex: RegExp;

    protected initAdditionalVar() {
        /**
         * Differents templates reloadable
         * @type {string}
         */
        this.TEMPLATE_PRODUCTS = TemplateProductsEnum.PRODUCTS;
        this.TEMPLATE_FILTERS = 'facets';

        /**
         * Containers
         * @type {string}
         */
        this.productsContainerId = '#products-container';

        // TODO Voir si préférable d'utiliser le conteneur #filters-panel qui englobe le titre et le lien de reset
        // this.filtersContainerId = '#filters-panel';
        this.filtersContainerId = '#facets-container';

        this.loaderContainerId = '#loading';

        /**
         * Current selected filters
         * @type {{object}}
         */
        this.selectedFilters = {};

        /**
         * Full hash value (with hashtag #)
         * @type {string}
         */
        this.hashCurrent = null;

        /**
         * Hash value without # (hashtag)
         * Used as key in javascript object to store/recover cache
         * @type {string}
         */
        this.hashKey = null;

        /**
         * To store already retrieved content
         * @type {{object}}
         */
        this.cache = {};

        /**
         * Default product filters values
         * @type {number}
         */
        this.productsPage = 1;
        this.productsOrder = this.view.dataset.orderDefault ?? 1;
        this.productsQuantity = 12;

        /**
         * Regex
         */
        this.productsPageRegex = /#?&?p=(\d+)/i;
        this.productsOrderRegex = /#?&?t=(\d+)/i;
        this.productsQuantityRegex = /#?&?q=(\d+)/i;
        this.filtersRegex = /#?&?f(\d*)=((\d+,?)+)/i;
        this.templatesRegex = /#?&?tpl=(\w+)/i;
    }

    init(): void {
        this.initMobileToggle();
        this.initViewEvent();
        this.initSortEvent();
        this.initPagination();
        this.initQuantityEvent();
        this.resetFiltersEvent([this.TEMPLATE_PRODUCTS]);
        this.updateContentFromHash();
    }

    /**
     * Update hash url and products contents
     * @param templates
     */
    refreshHashAndContent(templates?: string[]) {
        this.updateHash();
        this.getCurrentProductsContent(templates);
    }

    /**
     * Initialise l'evet listener qui mermet d'afficher la liste des filtres en mobile
     */
    initMobileToggle() {
        const mobileBtn = this.view.querySelector('.filter-m');
        if (mobileBtn) {
            mobileBtn.addEventListener('click', () => {
                const filters = this.view.querySelectorAll('.c-mob');
                filters.forEach((filter) => {
                    filter.classList.toggle('show');
                });
                mobileBtn.classList.toggle('cross');
            });
        }
    }

    /**
     * Initialise les evts lorsque l'on clique sur la nav permettant de changer de vue liste / palette /stock
     */
    initViewEvent() {
        const container = this.getProductsContainer();
        if (container) {
            container.querySelectorAll('.nav-products .nav-link').forEach((item: HTMLLinkElement) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.productsPage = 1; // Si changement de vue on reset la pagination
                    // On actualise le nom du tpl
                    const href = new URL(item.href);
                    this.updateTemplateFromHash(decodeURIComponent(href.hash));
                    // Maj du tpl
                    this.refreshHashAndContent([this.TEMPLATE_PRODUCTS]);
                });
            });
        }
    }

    /**
     * Init Sort event
     */
    initSortEvent() {
        const container = this.getProductsContainer();
        if (container) {
            container.querySelectorAll('#dropdownSortContainer .dropdown-item').forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.enableLoader();
                    this.productsPage = 1; // Si changement d'ordre on reset la pagination
                    this.productsOrder = item.getAttribute('data-value') ?? 1;
                    this.refreshHashAndContent([this.TEMPLATE_PRODUCTS]);
                });
            });
        }
    }

    /**
     * Init paginate event
     * @TODO à tester
     */
    initPagination() {
        const container = this.getProductsContainer();
        if (container) {
            container.querySelectorAll('.pagination a').forEach((paginate) => {
                paginate.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.enableLoader();
                    const href = paginate.getAttribute('href');

                    const [, second] = href ? href.split('page=') : [1];
                    this.productsPage = second;
                    this.refreshHashAndContent([this.TEMPLATE_PRODUCTS]);
                    window.scrollTo(0, 160);
                    return false;
                });
            });
        }
    }

    /**
     * Init quantité d'éléments par page
     */
    initQuantityEvent() {
        const container = this.getProductsContainer();
        if (container) {
            container.querySelectorAll('#dropdownQuantityContainer .dropdown-item').forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.enableLoader();
                    this.productsPage = 1; // Si changement de quantité d'éléments par page on reset la pagination
                    this.productsQuantity = item.getAttribute('data-value') ?? 1;
                    this.refreshHashAndContent([this.TEMPLATE_PRODUCTS]);
                });
            });
        }
    }

    rebindEvents() {
        this.initViewEvent();
        this.initSortEvent();
        this.initPagination();
        this.initQuantityEvent();
    }

    rebindMounts() {
        const container = this.getProductsContainer();
        if (container) {
            // reload product card events
            container.querySelectorAll('[data-mount="ProductCard"]').forEach((card: HTMLElement) => {
                (() => new ProductCard(card))();
            });
            // reload product card events
            container.querySelectorAll('[data-mount="ColorCard"]').forEach((card: HTMLElement) => {
                (() => new ColorCard(card))();
            });
            // si on est identifié on reload product Favorite events
            if (document.body.getAttribute('data-auth') === 'true') {
                container.querySelectorAll('[data-mount="Favorite"]').forEach((element: HTMLElement) => {
                    (() => new Favorite(element))();
                });
            } else {
                // sinon on reload Login
                container.querySelectorAll('[data-mount="Login"]').forEach((element: HTMLElement) => {
                    (() => new Login(element))();
                });
            }
        }
    }

    getProductsContainer() {
        return ProductFilter.getContainer(this.productsContainerId);
    }

    getFiltersContainer() {
        return ProductFilter.getContainer(this.filtersContainerId);
    }

    getLoaderContainer() {
        return ProductFilter.getContainer(this.loaderContainerId);
    }

    enableLoader() {
        const loaderContainer = this.getLoaderContainer();
        if (loaderContainer) {
            loaderContainer.classList.remove('hidden');
        }
    }

    disableLoader() {
        const loaderContainer = this.getLoaderContainer();
        if (loaderContainer) {
            loaderContainer.classList.add('hidden');
        }
    }

    /**
     * Analyse hash, and update content with hash params
     */
    updateContentFromHash() {
        this.hashCurrent = decodeURIComponent(window.location.hash);
        this.hashKey = this.hashCurrent.replace(/^#/, '');

        // Update current page from current hash
        this.updateTemplateFromHash();

        this.updatePaginationFromHash();

        this.updateQuantityFromHash();

        this.updateOrderFromHash();

        // Mise à jour des filtres par rapport à l'URL Hash. Il ne faut passer ici qu'au chargement de la page.
        // Si on y passe 2 fois, on risque d'écraser les filtres enregistrés.
        // Comme la liste de filtre n'est chargé qu'après le getCurrentProductsContent(), on cochera les filtres plus tard.
        this.updateFiltersFromHash();

        this.getCurrentProductsContent();
    }

    /**
     * Update CurrentPage using current URL hash
     */
    updateTemplateFromHash(hash: string | null = null) {
        const match = this.templatesRegex.exec(hash ?? this.hashCurrent ?? '');
        if (match != null && Object.values(TemplateProductsEnum).includes(match?.[1] as TemplateProductsEnum)) {
            this.TEMPLATE_PRODUCTS = match?.[1] as TemplateProductsEnum;
        }
    }

    /**
     * Update CurrentPage using current URL hash
     */
    updatePaginationFromHash() {
        const match = this.productsPageRegex.exec(this.hashCurrent ?? '');
        if (match != null) {
            this.productsPage = match?.[1];
        }
    }

    /**
     * Update Quantity using current URL hash
     */
    updateQuantityFromHash() {
        const match = this.productsQuantityRegex.exec(this.hashCurrent ?? '');

        if (match != null) {
            // Update the products current page
            this.productsQuantity = match[1];
        }
    }

    /**
     * Update Order using current URL hash
     */
    updateOrderFromHash() {
        const match = this.productsOrderRegex.exec(this.hashCurrent ?? '');
        if (match != null) {
            this.productsOrder = match?.[1];
        }
    }

    /**
     * Update Filters using current URL hash
     */
    updateFiltersFromHash() {
        this.filtersRegex = /#?&?f(\w+)=([^&]*)/gi;
        const matches = [...(this.hashCurrent ?? '').matchAll(this.filtersRegex)];
        matches.forEach((match) => {
            const filterId = match?.[1]; // Capture `stock`
            const filterValues = match?.[2]; // Capture `true`
            this.manageFilters(filterId, filterValues);
        });

        // On va aller check les checkboxes
        this.checkCheckboxes();
    }

    /**
     * Retrieve the content adapted to the current selected filters
     */
    getCurrentProductsContent(templates: string[] | null = null) {
        let tpls = templates;
        let initMode = false;
        if (tpls === null) {
            tpls = [this.TEMPLATE_PRODUCTS, this.TEMPLATE_FILTERS];
            initMode = true;
        }

        // Check if cache content exist
        if (this.isCurrentFilterCached(tpls)) {
            // If it does, then show the cached content
            this.updateContent();
        } else {
            // If not, then request for content and cache it
            this.sendFilterRequest(tpls, initMode);
        }
    }

    /**
     * Check if system has already been load the current requested hashKey
     * @returns {boolean}
     */
    isCurrentFilterCached(templates: string[]) {
        let isCached = true;

        if (!Object.prototype.hasOwnProperty.call(this.cache, this.hashKey)) {
            this.cache[this.hashKey ?? ''] = [];
            isCached = false;
        }

        this.cache[this.hashKey ?? ''].forEach((key: any) => {
            if (!isCached) return;

            isCached = templates.indexOf(key) > -1;
        });
        return isCached;
    }

    /**
     * Save retrieved data into cache object
     * @param content
     * @param templates
     */
    pushCachedData(content: any, templates: string[]) {
        if (!Object.prototype.hasOwnProperty.call(this.cache, this.hashKey)) {
            this.cache[this.hashKey ?? ''] = [];
        }
        templates.forEach((template) => {
            if (Object.prototype.hasOwnProperty.call(content, template)) {
                this.cache[this.hashKey ?? ''][template] = content[template];
            }
        });
    }

    /**
     * Update the content of the page with current hashKey
     *
     * @param initMode  Défini si on est au chargement pour activer l'initialisation des events des filtres une seule fois
     */
    updateContent(initMode: boolean = false) {
        const data = this.cache[this.hashKey ?? ''];

        if (data != null) {
            Object.entries(data).forEach(([key, item]) => {
                let container;
                if (key === this.TEMPLATE_PRODUCTS) {
                    container = this.getProductsContainer();
                }
                // On initialise les filtres uniquement à l'init mais surtout pas au rechargement d'un template
                // qui est déjà dans le cache
                if (key === this.TEMPLATE_FILTERS && initMode) {
                    container = this.getFiltersContainer();
                }

                if (typeof container !== 'undefined') {
                    container.innerHTML = item as string;
                }
            });
            // On rebind mes evts
            this.rebindEvents();
            this.rebindMounts();
            this.disableLoader();
            // On force le rechargement des filtres à partir de l'URL Hash
            if (initMode) {
                // On met juste à jour les checkbox après avoir chargé le panneau de filtre
                // Les filtres chargés depuis l'URL ont déjà été enregistrés.
                // Si on relance un manage filter, on va faire un reset des filtres qui poserait problème
                this.checkCheckboxes();
                this.initBlockFiltersEvents([this.TEMPLATE_PRODUCTS]);
            }
        }
    }

    /**
     * Update hash class params and propagate the new hash into the URL
     */
    updateHash() {
        this.hashKey = '1';

        /*
         * Hash for templates
         */
        this.hashKey += `&tpl=${this.TEMPLATE_PRODUCTS}`;
        /*
         * Hash for products
         */
        this.hashKey += `&p=${this.productsPage}`;
        this.hashKey += `&t=${this.productsOrder}`;
        this.resetProductQuantityIfNecessary();
        this.hashKey += `&q=${this.productsQuantity}`;
        /*
         * Hash for filters
         */
        Object.entries(this.selectedFilters).forEach(([key, filterValues]) => {
            this.hashKey += `&f${key}=${filterValues.join(',')}`;
        });

        window.location.hash = `#${this.hashKey}`;
    }

    /**
     * On force la valeur par défaut du nombre d'élément par page si l'on a changé de template.
     * Le template couleur nécessite, par défaut, 45 éléments par page.
     */
    resetProductQuantityIfNecessary() {
        const container = this.getProductsContainer();
        if (container) {
            // Instanciation locale pour caster la valeur en int
            let currentProductQuantity: number;
            if (typeof this.productsQuantity === 'string') {
                currentProductQuantity = parseInt(this.productsQuantity, 10);
            } else {
                currentProductQuantity = this.productsQuantity;
            }
            if (
                this.TEMPLATE_PRODUCTS === TemplateProductsEnum.COLORS
                && !PageEnum.COLORS.includes(currentProductQuantity)
            ) {
                // @ts-ignore
                // eslint-disable-next-line prefer-destructuring
                this.productsQuantity = PageEnum.COLORS[0];
            }
            if (
                this.TEMPLATE_PRODUCTS === TemplateProductsEnum.PRODUCTS
                && !PageEnum.PRODUCTS.includes(currentProductQuantity)
            ) {
                // @ts-ignore
                // eslint-disable-next-line prefer-destructuring
                this.productsQuantity = PageEnum.PRODUCTS[0];
            }
        }
    }

    /**
     * Send request with template required to response,
     * filters, pages, orders, quantities
     * @param templates Templates required to json response
     * @param initMode  Défini si on est au chargement pour activer l'initialisation des events des filtres une seule fois
     */
    sendFilterRequest(templates: string[], initMode: boolean = false) {
        this.resetProductQuantityIfNecessary();
        const url = new URL(window.location.href);
        const urlParams = new URLSearchParams(url.search);
        urlParams.set('tpl', JSON.stringify(templates));
        urlParams.set('p', this.productsPage.toString());
        urlParams.set('q', this.productsQuantity.toString());
        urlParams.set('t', this.productsOrder.toString());
        urlParams.set('filters', JSON.stringify(this.selectedFilters));
        url.search = urlParams.toString();

        fetch(url, {
            method: 'GET',
            headers: Helper.createFetchHeader(),
        }).then((response) => Promise.all([response, response.json()]))
            .then(([response, data]) => {
                if (!response.ok) {
                    throw new Error(data.message);
                }
                // Save retrieved data to cache array
                this.pushCachedData(data.templates, templates);
                // Then update content
                this.updateContent(initMode);
                // Transfert des données à la datalayer de GTM s'il y en a
                ProductFilter.processGtmData(data.gtm);
                ProductFilter.processMtmData(data.mtm);
            });
    }

    resetFiltersEvent(templates: string[]) {
        // Remplacement du conteneur par le parent pour éviter les problemes de chargement du bouton Reset
        // const filterContainer = this.getFiltersContainer();
        const filterContainer = ProductFilter.getContainer('#filters-panel');
        if (filterContainer) {
            const reset = filterContainer.querySelector('.reset-all-filters');
            if (reset) {
                reset.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.enableLoader();
                    this.selectedFilters = {};
                    this.clearFilters();
                    this.updateHash();
                    this.updateContentFromHash();
                    filterContainer.querySelectorAll('input[type="checkbox"]').forEach((input: HTMLInputElement) => {
                        input.removeAttribute('checked');
                        input.checked = false;
                    });
                    this.getCurrentProductsContent(templates);
                    this.refreshHashAndContent(templates);
                    this.initBlockFiltersEvents(templates);
                });
            }
        }
    }

    initBlockFiltersEvents(templates: string[]) {
        const filterContainer = this.getFiltersContainer();
        if (filterContainer) {
            filterContainer.querySelectorAll('input[type="checkbox"][data-filter]').forEach((input: HTMLInputElement) => {
                input.addEventListener('change', () => {
                    this.enableLoader();
                    this.clearFilters([this.TEMPLATE_PRODUCTS]);
                    this.manageFilters(input.getAttribute('data-filter') ?? '', input.value);
                    // Dans le cas ou c'est une catégorie qui a des enfants on va également cocher tous ses enfants
                    if (input.classList.contains('has-children')) {
                        this.checkChildren(input);
                    }
                    this.refreshHashAndContent([this.TEMPLATE_PRODUCTS]);
                });
            });
        }
    }

    checkChildren(input: HTMLInputElement) {
        const parent = input.closest('.accordion-item');
        if (parent) {
            const children = parent.querySelectorAll('.accordion-collapse input[type="checkbox"]');
            children.forEach((child: HTMLInputElement) => {
                if ((input.checked && !child.checked) || (!input.checked && child.checked)) {
                    if (input.checked) {
                        child.checked = true;
                    } else {
                        child.removeAttribute('checked');
                        child.checked = false;
                    }
                    this.manageFilters(child.getAttribute('data-filter') ?? '', child.value);
                }
            });
        }
    }

    manageFilters(filterId: string, filterValue: string | number, renew: boolean | null = null) {
        if (!Object.prototype.hasOwnProperty.call(this.selectedFilters, filterId) || renew === true) {
            this.selectedFilters[filterId] = [];
        }
        const index = this.selectedFilters[filterId].indexOf(filterValue);
        if (index > -1) {
            this.selectedFilters[filterId].splice(index, 1);
            if (this.selectedFilters[filterId].length === 0) {
                delete this.selectedFilters[filterId];
            }
        } else {
            this.selectedFilters[filterId].push(filterValue);
        }
    }

    clearFilters(templates: string[] | null = null) {
        let tpls = templates;
        if (tpls == null) {
            tpls = [this.TEMPLATE_PRODUCTS];
        }

        if (tpls.indexOf(this.TEMPLATE_PRODUCTS) > -1) {
            this.productsPage = 1;
        }
    }

    deleteFilter(filterId: string) {
        const id = parseInt(filterId, 10);

        if (Number.isNaN(id)) {
            return;
        }

        if (Object.prototype.hasOwnProperty.call(this.selectedFilters, id)) {
            delete this.selectedFilters[id];
        }
    }

    /**
     * Return container
     * @param containerId
     * @returns {undefined|HTMLElement}
     */
    private static getContainer(containerId: string) {
        const container = document.querySelector(containerId);
        if (container != null) return container;

        return undefined;
    }

    private checkCheckboxes() {
        if (Object.keys(this.selectedFilters).length > 0) {
            Object.entries(this.selectedFilters).forEach(([filterKey, values]) => {
                // Assurez-vous que 'values' est traité comme un tableau, même s'il s'agit d'une seule valeur
                if (!Array.isArray(values)) {
                    values = [values];// Transforme en tableau si ce n'est pas déjà un tableau
                }

                // Parcours des valeurs (qui sont maintenant toujours dans un tableau)
                (values as Array<string | number>).forEach((value: string | number | Array<string | number>) => {
                    if (Array.isArray(value)) {
                        // Si 'value' est un tableau, on le parcourt et recherche chaque sous-valeur
                        value.forEach((subValue) => {
                            this.checkAndSetCheckbox(filterKey, subValue);
                        });
                    } else {
                        // Si 'value' est une chaîne de caractères qui contient des virgules, on la divise
                        if (typeof value === 'string' && value.includes(',')) {
                            const splitValues = value.split(',');// Divise la chaîne par les virgules
                            splitValues.forEach((splitValue) => {
                                this.checkAndSetCheckbox(filterKey, splitValue.trim());// Supprime les espaces autour des valeurs
                            });
                        } else {
                            this.checkAndSetCheckbox(filterKey, value);
                        }
                    }
                });
            });
        }
    }

    // Fonction pour rechercher et cocher l'input correspondant à la valeur
    private checkAndSetCheckbox(filterKey: string, value: string | number) {
        // Recherche de l'input checkbox correspondant
        const input = document.querySelector(`input[type="checkbox"][data-filter="${filterKey}"][value="${value}"]`);
        // Si l'input est trouvé, on le coche
        if (input) {
            (input as HTMLInputElement).checked = true;
        }
    }

    /**
     * Transfert des données GTM à la datalayer si elles sont transmises
     * @param gtm
     */
    private static processGtmData(gtm: []) {
        if (typeof (window as any).dataLayer !== 'undefined' && gtm !== undefined) {
            // Envoi des données à GTM - MaJ GA4
            HegydGtm.init();
            HegydGtm.pushToDatalayer(gtm, false);
        }
    }

    private static processMtmData(mtm: []) {
        if (typeof (window as any)._mtm !== 'undefined' && mtm !== undefined) {
            // Envoi des données à GTM
            Object.keys(mtm).forEach((k: any) => {
                (window as any)._mtm.push(mtm[k]);
            });
        }
    }
}
